import { render } from "./CreateSurvey.vue?vue&type=template&id=39b8b7c2"
import script from "./CreateSurvey.vue?vue&type=script&lang=js"
export * from "./CreateSurvey.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__